import { Container, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Landing() {
  const [rerollDescriptionCost, setRerollDescriptionCost] = useState(100); // Default $1.00

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const res = await fetch("/api/pricing");
        if (res.ok) {
          const data = await res.json();
          setRerollDescriptionCost(data.rerollDescriptionCost || 100);
        }
      } catch (error) {
        console.error("Error fetching pricing:", error);
      }
    };
    fetchPricing();
  }, []);

  return (
    <div className="brutal-landing">
      {/* Hero Section */}
      <section className="brutal-hero">
        <Container>
          <div className="brutal-hero-content">
            <div className="brutal-title-box">
              <h1 className="brutal-title">
                OWN A PIECE<br />
                OF TIME
              </h1>
              <div className="brutal-accent-box"></div>
            </div>
            
            <p className="brutal-subtitle">
              EVERY DAY IS UNIQUE. CLAIM IT FOR YOURSELF.
              ONCE REGISTERED, THAT DAY BELONGS TO YOU ALONE.
            </p>
            
            <div className="brutal-buttons">
              <Button 
                as={Link} 
                to="/registry" 
                className="brutal-btn brutal-btn-primary"
              >
                VIEW REGISTRY
              </Button>
              <Button 
                as={Link} 
                to="/login" 
                className="brutal-btn brutal-btn-secondary"
              >
                LOGIN
            </Button>
            </div>
          </div>
        </Container>
      </section>

      {/* Scarcity Section */}
      <section className="brutal-scarcity">
        <Container>
          <div className="brutal-section-box">
            <h2 className="brutal-heading-white">
              SCARCITY<br />
              MAKES IT YOURS
            </h2>
            <div className="brutal-divider"></div>
            <p className="brutal-text-white">
              EACH DAY CAN ONLY BE OWNED BY ONE PERSON.
              REGISTER A DAY, SECURE YOUR OWNERSHIP,
              AND NO ONE ELSE CAN CLAIM IT UNLESS YOU RESELL.
              <br />
              IT'S ALSO A UNIQUE GIFT — SURPRISE YOUR PARENTS WITH THEIR ANNIVERSARY,
              OR CELEBRATE A FRIEND'S BIRTHDAY BY SECURING THEIR SPECIAL DAY.
            </p>
            <Button 
              as={Link} 
              to="/registry" 
              className="brutal-btn brutal-btn-inverse"
            >
              EXPLORE AVAILABLE DAYS
            </Button>
          </div>
        </Container>
      </section>

      {/* Features Section */}
      <section className="brutal-features">
        <Container>
          <h2 className="brutal-heading-black text-center mb-5">
            WHY CLAIM<br />
            A MOMENT?
          </h2>
          
            <Row className="g-4">
              {[
                { 
                  title: "PERSONAL MILESTONES", 
                  desc: "Secure your birthdays, anniversaries, or memorable days. Celebrate the moments that define your life in a way that lasts forever.",
                  accent: "#FF0000"
                },
                { 
                  title: "HISTORIC DATES", 
                  desc: "Own iconic historical moments and be part of history's story. From legendary sports victories to landmark cultural events, preserve the moments everyone remembers.",
                  accent: "#0000FF"
                },
                { 
                  title: "SIGNIFICANT ACHIEVEMENTS", 
                  desc: "Mark your organization's key successes and milestones. Every achievement—whether a product launch, award, or major breakthrough—can be claimed and celebrated as yours.",
                  accent: "#00FF00"
                }
              ].map((item, idx) => (
                <Col md={4} key={idx}>
                <div className="brutal-feature-card">
                  <div 
                    className="brutal-feature-accent"
                    style={{ backgroundColor: item.accent }}
                  ></div>
                  <div className="brutal-feature-content">
                    <h3 className="brutal-feature-title">{item.title}</h3>
                    <p className="brutal-feature-text">{item.desc}</p>
                  </div>
                </div>
                </Col>
              ))}
            </Row>
        </Container>
      </section>

      {/* Current Features Section */}
      <section className="brutal-current-features">
        <Container>
          <div className="brutal-section-box">
            <h2 className="brutal-heading-white text-center mb-5">
              CURRENT<br />
              FEATURES
            </h2>
            
            <div className="brutal-roadmap-container">
              <Row className="g-4 justify-content-center">
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-1">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge" style={{ background: "#00FF00", color: "#000000" }}>LIVE</div>
                      <h3 className="brutal-roadmap-title">REGISTER YOUR DAY</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      PURCHASE AND OWN ANY DAY IN PAST OR FUTURE. 
                      ONCE REGISTERED, IT'S YOURS FOREVER. 
                      SECURE YOUR SPECIAL DATES.
                    </p>
                  </div>
                </Col>
                
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-2">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge" style={{ background: "#00FF00", color: "#000000" }}>LIVE</div>
                      <h3 className="brutal-roadmap-title">PDF CERTIFICATE</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      GENERATE AN OFFICIAL CERTIFICATE FOR YOUR DAY. 
                      DOWNLOAD AND SHARE YOUR OWNERSHIP PROOF.
                      <br />
                      <a 
                        href="/api/pdf/example" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ 
                          color: "#0000FF", 
                          textDecoration: "underline",
                          fontWeight: "900",
                          fontSize: "12px",
                          marginTop: "10px",
                          display: "inline-block"
                        }}
                      >
                        VIEW EXAMPLE →
                      </a>
                    </p>
                  </div>
                </Col>
                
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-4">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge" style={{ background: "#00FF00", color: "#000000" }}>LIVE</div>
                      <h3 className="brutal-roadmap-title">DISPLAY NAME</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      CUSTOMIZE YOUR DISPLAY NAME. 
                      REPRESENT YOURSELF HOW YOU WANT. 
                      CHANGE IT ANYTIME FROM YOUR PROFILE.
                    </p>
                  </div>
                </Col>
                
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-1">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge" style={{ background: "#00FF00", color: "#000000" }}>LIVE</div>
                      <h3 className="brutal-roadmap-title">VIEW REGISTRY</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      BROWSE ALL REGISTERED DAYS. 
                      SEE WHO OWNS WHICH DATES. 
                      EXPLORE THE COLLECTIVE TIMELINE.
                    </p>
                  </div>
                </Col>
                
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-2">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge" style={{ background: "#00FF00", color: "#000000" }}>LIVE</div>
                      <h3 className="brutal-roadmap-title">TITLES & DESCRIPTIONS</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      ADD PERSONAL TITLES AND DESCRIPTIONS TO YOUR DAYS. 
                      MAX 40 CHARACTERS. 
                      MAKE EACH DAY UNIQUELY YOURS.
                    </p>
                  </div>
                </Col>
                
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-4">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge" style={{ background: "#00FF00", color: "#000000" }}>LIVE</div>
                      <h3 className="brutal-roadmap-title">DESCRIPTION REROLL</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      REGENERATE DAY DESCRIPTIONS WITH AI. 
                      ADD YOUR SUGGESTIONS. 
                      ${(rerollDescriptionCost / 100).toFixed(2)} PER REROLL.
                    </p>
                  </div>
                </Col>
                
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-1">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge" style={{ background: "#00FF00", color: "#000000" }}>LIVE</div>
                      <h3 className="brutal-roadmap-title">REFERRAL PROGRAM</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      EARN FOR REFERRING. 
                      AFFILIATE PROGRAM AVAILABLE. 
                      EMAIL US FOR MORE INFO.
                      <br />
                      <a 
                        href="mailto:info@time-registry.com?subject=Referral Program Inquiry" 
                        style={{ 
                          color: "#0000FF", 
                          textDecoration: "underline",
                          fontWeight: "900",
                          fontSize: "12px",
                          marginTop: "10px",
                          display: "inline-block"
                        }}
                      >
                        EMAIL US →
                      </a>
                    </p>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-1">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div
                        className="brutal-roadmap-badge"
                        style={{ background: "#00FF00", color: "#000000" }}
                      >
                        LIVE
                      </div>
                      <h3 className="brutal-roadmap-title">BUG FINDING BOUNTY</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      FIND A BUG.  
                      REPORT IT RESPONSIBLY.  
                      GET REWARDED.
                      <br />
                      <a
                        href="mailto:info@time-registry.com?subject=Bug Bounty Report"
                        style={{
                          color: "#0000FF",
                          textDecoration: "underline",
                          fontWeight: "900",
                          fontSize: "12px",
                          marginTop: "10px",
                          display: "inline-block",
                        }}
                      >
                        EMAIL US →
                      </a>
                    </p>
                  </div>
                </Col>

              </Row>
            </div>
          </div>
        </Container>
      </section>

      {/* Roadmap Section */}
      <section className="brutal-roadmap">
        <Container>
          <div className="brutal-section-box">
            <h2 className="brutal-heading-white text-center mb-5">
              COMING<br />
              SOON
            </h2>
            
            <div className="brutal-roadmap-container">
              <Row className="g-4 justify-content-center">
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-1">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge">NEXT</div>
                      <h3 className="brutal-roadmap-title">MARKETPLACE</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      BUY AND SELL YOUR REGISTERED DAYS. 
                      TRANSFER OWNERSHIP. 
                      CREATE A MARKETPLACE FOR TIME.
                    </p>
                  </div>
                </Col>
        
                <Col md={3}>
                  <div className="brutal-roadmap-card brutal-roadmap-card-4">
                    <div className="brutal-roadmap-marker"></div>
                    <div className="brutal-roadmap-header">
                      <div className="brutal-roadmap-badge">FUTURE</div>
                      <h3 className="brutal-roadmap-title">HOURLY BREAKDOWN</h3>
                    </div>
                    <p className="brutal-roadmap-text">
                      OWN SPECIFIC HOURS WITHIN A DAY. 
                      GRANULAR CONTROL. 
                      BREAK DOWN TIME INTO SMALLER UNITS.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </section>

      {/* Brutalist CSS */}
      <style>{`
        .brutal-landing {
          overflow-x: hidden;
          font-family: 'Courier New', monospace;
        }

        /* Hero Section */
        .brutal-hero {
          min-height: 100vh;
          background: #FFFFFF;
          display: flex;
          align-items: center;
          padding: 60px 0;
          border-bottom: 8px solid #000000;
        }

        .brutal-hero-content {
          max-width: 900px;
          margin: 0 auto;
        }

        .brutal-title-box {
          position: relative;
          margin-bottom: 40px;
        }

        .brutal-title {
          font-size: 72px;
          font-weight: 900;
          line-height: 1.1;
          color: #000000;
          margin: 0;
          letter-spacing: -2px;
          text-transform: uppercase;
          font-family: 'Arial Black', 'Helvetica Bold', sans-serif;
        }

        .brutal-accent-box {
          position: absolute;
          top: -10px;
          right: -20px;
          width: 120px;
          height: 120px;
          background: #FFFF00;
          border: 6px solid #000000;
          transform: rotate(5deg);
          z-index: -1;
        }

        .brutal-subtitle {
          font-size: 18px;
          font-weight: 700;
          color: #000000;
          line-height: 1.6;
          margin-bottom: 50px;
          text-transform: uppercase;
          letter-spacing: 1px;
          max-width: 700px;
        }

        .brutal-buttons {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        /* Brutalist Buttons */
        .brutal-btn {
          padding: 20px 40px;
          font-size: 16px;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 2px;
          border: 5px solid #000000;
          border-radius: 0;
          transition: all 0.1s;
          font-family: 'Arial Black', 'Helvetica Bold', sans-serif;
          text-decoration: none;
          display: inline-block;
          box-shadow: 8px 8px 0px #000000;
        }

        .brutal-btn-primary {
          background: #000000;
          color: #FFFFFF;
        }

        .brutal-btn-primary:hover {
          background: #FFFFFF;
          color: #000000;
          transform: translate(4px, 4px);
          box-shadow: 4px 4px 0px #000000;
        }

        .brutal-btn-secondary {
          background: #FFFFFF;
          color: #000000;
        }

        .brutal-btn-secondary:hover {
          background: #000000;
          color: #FFFFFF;
          transform: translate(4px, 4px);
          box-shadow: 4px 4px 0px #000000;
        }

        .brutal-btn-inverse {
          background: #FFFFFF;
          color: #000000;
          border-color: #FFFFFF;
        }

        .brutal-btn-inverse:hover {
          background: #000000;
          color: #FFFFFF;
          border-color: #000000;
          transform: translate(4px, 4px);
          box-shadow: 4px 4px 0px #FFFFFF;
        }

        /* Scarcity Section */
        .brutal-scarcity {
          background: #000000;
          color: #FFFFFF;
          padding: 80px 0;
          border-bottom: 8px solid #FFFFFF;
        }

        .brutal-section-box {
          max-width: 800px;
          margin: 0 auto;
          text-align: center;
        }

        .brutal-heading-white {
          font-size: 56px;
          font-weight: 900;
          color: #FFFFFF;
          margin-bottom: 30px;
          line-height: 1.2;
          text-transform: uppercase;
          letter-spacing: -1px;
          font-family: 'Arial Black', 'Helvetica Bold', sans-serif;
        }

        .brutal-divider {
          width: 200px;
          height: 8px;
          background: #FFFFFF;
          margin: 30px auto;
        }

        .brutal-text-white {
          font-size: 18px;
          font-weight: 700;
          color: #FFFFFF;
          line-height: 1.8;
          margin-bottom: 40px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        /* Features Section */
        .brutal-features {
          background: #FFFFFF;
          padding: 80px 0;
        }

        .brutal-heading-black {
          font-size: 56px;
          font-weight: 900;
          color: #000000;
          line-height: 1.2;
          text-transform: uppercase;
          letter-spacing: -1px;
          font-family: 'Arial Black', 'Helvetica Bold', sans-serif;
        }

        .brutal-feature-card {
          background: #FFFFFF;
          border: 6px solid #000000;
          padding: 0;
          position: relative;
          box-shadow: 12px 12px 0px #000000;
          transition: all 0.1s;
          min-height: 250px;
        }

        .brutal-feature-card:hover {
          transform: translate(6px, 6px);
          box-shadow: 6px 6px 0px #000000;
        }

        .brutal-feature-accent {
          width: 100%;
          height: 12px;
          border-bottom: 6px solid #000000;
        }

        .brutal-feature-content {
          padding: 30px;
        }

        .brutal-feature-title {
          font-size: 24px;
          font-weight: 900;
          color: #000000;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-family: 'Arial Black', 'Helvetica Bold', sans-serif;
        }

        .brutal-feature-text {
          font-size: 14px;
          font-weight: 700;
          color: #000000;
          line-height: 1.6;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin: 0;
        }

        /* Current Features Section */
        .brutal-current-features {
          background: #000000;
          color: #FFFFFF;
          padding: 80px 0;
          border-top: 8px solid #FFFFFF;
        }

        .brutal-current-features .brutal-section-box {
          max-width: 1200px;
        }

        .brutal-current-features .brutal-roadmap-container {
          position: relative;
          padding: 40px 0;
        }

        /* Roadmap Section */
        .brutal-roadmap {
          background: #000000;
          color: #FFFFFF;
          padding: 80px 0;
          border-top: 8px solid #FFFFFF;
        }

        .brutal-roadmap .brutal-section-box {
          max-width: 1200px;
        }

        .brutal-roadmap-container {
          position: relative;
          padding: 40px 0;
        }

        .brutal-roadmap-card {
          background: #FFFFFF;
          border: 6px solid #FFFF00;
          padding: 0;
          position: relative;
          box-shadow: 12px 12px 0px #CCCC00;
          transition: all 0.1s;
          min-height: 200px;
          display: flex;
          flex-direction: column;
          height: 100%;
          z-index: 1;
        }

        .brutal-roadmap-card:hover {
          transform: translate(6px, 6px);
          box-shadow: 6px 6px 0px #CCCC00;
        }

        .brutal-roadmap-marker {
          position: absolute;
          left: 50%;
          top: -20px;
          transform: translateX(-50%);
          width: 30px;
          height: 30px;
          background: #FFFF00;
          border: 4px solid #000000;
          border-radius: 0;
          z-index: 2;
        }

        .brutal-roadmap-card-1 .brutal-roadmap-marker {
          left: auto;
          right: -15px;
          top: 50%;
          transform: translateY(-50%);
        }

        .brutal-roadmap-card-2 .brutal-roadmap-marker {
          left: -15px;
          top: 60%;
          transform: translateY(-50%);
        }

        .brutal-roadmap-card-4 .brutal-roadmap-marker {
          left: auto;
          right: -15px;
          top: 60%;
          transform: translateY(-50%);
        }

        .brutal-roadmap-header {
          background: #FFFF00;
          border-bottom: 6px solid #000000;
          padding: 20px 30px;
          display: flex;
          align-items: center;
          gap: 15px;
          flex-wrap: wrap;
        }

        .brutal-roadmap-badge {
          background: #000000;
          color: #FFFF00;
          padding: 8px 16px;
          font-size: 12px;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 2px;
          border: 3px solid #000000;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .brutal-roadmap-title {
          font-size: 24px;
          font-weight: 900;
          color: #000000;
          margin: 0;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-family: 'Arial Black', 'Helvetica Bold', sans-serif;
          line-height: 1.2;
          flex: 1;
        }

        .brutal-roadmap-text {
          font-size: 14px;
          font-weight: 700;
          color: #000000;
          line-height: 1.8;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin: 0;
          padding: 30px;
          flex: 1;
        }

        @media (max-width: 768px) {
          .brutal-roadmap-marker {
            display: none;
          }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .brutal-hero {
            padding: 40px 0;
            min-height: auto;
          }
          
          .brutal-title {
            font-size: 36px;
            line-height: 1.2;
          }

          .brutal-heading-white,
          .brutal-heading-black {
            font-size: 28px;
            line-height: 1.3;
          }

          .brutal-accent-box {
            width: 60px;
            height: 60px;
            top: -5px;
            right: -5px;
          }

          .brutal-buttons {
            flex-direction: column;
            gap: 15px;
          }

          .brutal-btn {
            width: 100%;
            min-height: 44px;
          }
          
          .brutal-feature-card {
            min-height: auto;
          }
          
          .brutal-features {
            padding: 40px 0;
          }
          
          .brutal-current-features {
            padding: 40px 0;
          }
          
          .brutal-roadmap {
            padding: 40px 0;
          }
        }
      `}</style>
    </div>
  );
}
